// 数据交互-Flutter
import { EventBus } from "@saas/components/src/utils/event-bus";
import store from "@saas/store/src/index.js";
import {
  setToken,
  setRefreshToken,
  removeToken,
  removeRefreshToken,
} from "@saas/service-api/src/plugins/auth";
import types from "@saas/store/src/types.js";
window.getInfoFromFlutter = (info) => {
  console.log("getInfoFromFlutter>>>", info);
  console.log("getInfoFromFlutter>>>", JSON.parse(info));
  let { action = "", params = {} } = JSON.parse(info);
  switch (action) {
    case "setToken":
      console.log("setToken", params);
      if (params.isLogin) {
        // 存储token
        params.accessToken && setToken(params.accessToken);
        params.refreshToken && setRefreshToken(params.refreshToken);
        // 获取用户信息
        store.dispatch("getProfile");
      } else {
        removeToken();
        removeRefreshToken();
        store.commit(types.CHANGE_PROFILE, {
          profile: {},
        });
      }
      EventBus.$emit("setToken", params.isLogin);
      break;
    case "refreshToken":
      params.accessToken && setToken(params.accessToken);
      params.accessToken && setRefreshToken(params.refreshToken);
      break;
  }
};
